import styles from 'src/pages/ManageAccountPage/components/APIKeys/components/ContactOwnerButton/ContactOwnerButton.module.scss';
import { Button } from 'src/v2/commonComponents/Button';
import { useTeamInfo, useVisible } from 'src/hooks';
import { Modal } from 'src/components/Modal';

export const ContactOwnerButton = () => {
  const { isVisible, onVisibilitySet, onVisibilityRemove } = useVisible(false);
  const { teamInfo } = useTeamInfo();

  return (
    <div className={styles.root}>
      <Button onClick={onVisibilitySet}>Contact Owner</Button>
      <Modal
        open={isVisible}
        onClose={onVisibilityRemove}
        className={styles.contactNinjaModal}
        overlayClassName={styles.overlay}
        blockScroll={false}
      >
        <div className={styles.root}>
          <h4 className={styles.title}>Request API details</h4>
          <span className={styles.text}>
            To get API key details, please contact your workspace owner at{' '}
            <a className={styles.link} href={`mailto:${teamInfo?.owner_email}`}>
              {teamInfo?.owner_email}
            </a>
          </span>
          <div className={styles.buttonRow}>
            <Button onClick={onVisibilityRemove}>Close</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
